<main class="section-padding" style="padding-top: 20px;">
    <div class="container">

        <!-- Property Header -->
        <div class="property-header" *ngIf="propertyData && isPropertyValid">
            <div>
                <h1 class="page-title" *ngIf="propertyData.property_name">{{propertyData.property_name}}</h1>
                <p style="font-size: 0.9rem; color: #777;"
                    *ngIf="propertyData.PropertyToMasterCityData && propertyData.PropertyToMasterCityData.city_name">
                    {{propertyData.address}} {{propertyData.PropertyToMasterCityData.city_name}}</p>
            </div>
            <div class="price" *ngIf="propertyData && propertyData.price">
                {{shared.formatPriceAED(propertyData.price)}} {{propertyData.selling_type == 2 ? ("/" +
                paymentType(propertyData.payment_type)) : ''}}
            </div>
        </div>
        <!-- Top Gallery and Map/Contact Section -->
        <div class="top-gallery-grid" *ngIf="propertyImages && propertyImages.length > 0">
            <!-- Main Property Image -->
            <div class="main-image-wrapper" *ngIf="propertyImages[0]">
                <img [src]="shared.getImageURL(propertyImages[0].image)" alt="Main Property Image"
                    class="blurred-placeholder">
            </div>

            <!-- Map and Contact Agent Placeholder -->
            <div class="map-contact-wrapper">
                <div class="map-card" *ngIf="lat != 0 && lng != 0">
                    <iframe [src]="iframeUrl | safe: 'resourceUrl'" width="100%" height="100%" frameborder="0"
                        style="border:0; border-radius: 12px;" allowfullscreen="" tabindex="0"></iframe>
                    <div class="map-label">Location on Map</div>
                    <div class="pin-icon"></div>
                </div>

                <div class="contact-agent-card" style="height: auto;">
                    <h3 class="text-center">Contact Us</h3>
                    <div style="font-size: 0.85rem; color: #ccc;"></div>
                    <div class="mt-3">
                        <a class="btn btn-social w-100 mb-2 d-flex align-items-center justify-content-center"
                            href="javascript:void(0)"
                            target="_blank"
                            (click)="openInquiryModal()">
                            <span>Connect</span>
                        </a>
                        <a class="btn btn-social mb-2 w-100 d-flex align-items-center justify-content-center"
                            [href]="shared.isUserLoggedIn ? 'tel:' + developerMobile : 'javascript:void(0)'"
                            (click)="onPopup('call')">
                            <i class="fa fa-phone me-2"></i>
                            <span>Call</span>
                        </a>

                        <a class="btn btn-social mb-2 w-100 d-flex align-items-center justify-content-center"
                            [href]="shared.isUserLoggedIn ? 'mailto:' + developerEmail : 'javascript:void(0)'"
                            (click)="onPopup('mail')">
                            <i class="fa fa-envelope me-2"></i>
                            <span>Email</span>
                        </a>

                        <a class="btn whatsapp-button w-100 d-flex align-items-center justify-content-center"
                            [href]="shared.isUserLoggedIn ? 'https://wa.me/' + developerWhatsappNumber : 'javascript:void(0)'"
                            target="_blank"
                            (click)="onPopup('whatsapp')">
                            <i class="fa fa-whatsapp me-2"></i>
                            <span>WhatsApp</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content-grid" *ngIf="propertyData">
            <div class="main-details-column">
                <div class="detail-card description-content" *ngIf="propertyData.resale_description">
                    <h2 class="section-heading">Description</h2>
                    <p [innerHTML]="propertyData.resale_description"></p>
                </div>
                <div class="detail-card">
                    <h2 class="section-heading">Property Details</h2>
                    <div class="property-spec-grid">
                        <div>
                            <div class="spec-item">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z" />
                                    </svg>
                                    Property type
                                </span>
                                <span class="spec-value" *ngIf="propertyData.propertyTypeValue">{{propertyData.propertyTypeValue}}</span>
                            </div>
                            <div class="spec-item">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 5.69l5-2.73v10.92l-5 2.73-5-2.73V2.96l5 2.73zm0 14.62l-5-2.73V8.4l5 2.73 5-2.73v9.58l-5 2.73z" />
                                    </svg>
                                    Bedrooms
                                </span>
                                <span class="spec-value"
                                    *ngIf="propertyData.no_of_bedrooms !== null && propertyData.no_of_bedrooms !== 0 && propertyData.no_of_bedrooms !== '0'">{{propertyData.no_of_bedrooms}}</span>
                            </div>
                            <div class="spec-item">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 6.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zM16 2l-1-1h-2v2H9V1H7L6 2v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2h-2V2zM5 20V8h14v12H5zm14-12H5V6h14v2z" />
                                    </svg>
                                    Bathrooms
                                </span>
                                <span class="spec-value"
                                    *ngIf="propertyData.no_of_bathrooms !== null && propertyData.no_of_bathrooms !== 0 && propertyData.no_of_bathrooms !== '0'">{{propertyData.no_of_bathrooms}}</span>
                            </div>
                        </div>
                        <div>
                            <div class="spec-item">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8z" />
                                    </svg>
                                    Area (sqft)
                                </span>
                                <span class="spec-value" *ngIf="propertyData.plot_area">{{propertyData.plot_area}}</span>
                            </div>
                            <div class="spec-item" *ngIf="propertyData.property_construction_type">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 11c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm6-5c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1zm-6 0c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-6 20h12v-2H6v2zm12-4H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2z" />
                                    </svg>
                                    Construction type
                                </span>
                                <span class="spec-value">{{propertyData.property_construction_type == 1 ? 'Ready to Move' : 'Off plan'}}</span>
                            </div>
                            <div class="spec-item">
                                <span class="spec-label">
                                    <svg class="spec-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-4 7h8v2H8V8zm0 4h8v2H8v-2z" />
                                    </svg>
                                    Status
                                </span>
                                <span class="spec-value" style="color: #4CAF50;">{{propertyData.selling_type == 1 ? 'For Sale' : 'For Rent'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-card">
                    <h2 class="section-heading">Amenities</h2>
                    <div class="property-spec-grid">
                        <ng-container *ngFor="let i of amenitiesData">
                            <div class="spec-item">
                                <span class="spec-label">
                                    <span class="fa fa-check-circle icon spec-icon"
                                        style="fill: #007bff; color: #007bff;"></span>
                                    {{i.name}}
                                </span>
                                <span class="spec-value">{{i.value}}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let a2 of propertyData.amenities_json2">
                            <div class="spec-item">
                                <span class="spec-label">
                                    <span class="fa fa-check-circle icon spec-icon"
                                        style="fill: #007bff; color: #007bff;"></span>
                                    {{a2}}
                                </span>
                                <span class="spec-value">Yes</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ng-container *ngIf="propertyData.payment_plan && propertyData.payment_plan.length > 0">
                    <div class="detail-card">
                        <h2 class="section-heading">Payment Plan</h2>
                        <ul class="nearby-list">
                            <li class="nearby-category">
                                <ul>
                                    <li class="nearby-item" *ngFor="let pp of propertyData.payment_plan">
                                        <span class="nearby-item-name">- {{pp.payment}}</span>
                                        <span class="nearby-item-distance">{{shared.capitalizeWords(pp.label)}}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </ng-container>

                <!-- Video Section (Placeholder - integrate your video player if available) -->
                <!-- <div class="video-tour-wrapper">
                    <div class="video-placeholder">
                        <div class="play-button" onclick="alert('Video playing!')">
                            <svg viewBox="0 0 24 24">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </div>
                    </div>
                </div> -->

            </div>

            <!-- RIGHT COLUMN: Sidebar (Contact, Featured, Related) -->
            <div class="sidebar-column">

                <!-- Contact Agent Form -->
                
                   
                    <div class="mt-3">
                        <button *ngIf="is_fav" class="btn fav w-100 mb-2">
                            <i class="fa fa-solid fa-heart social-icon" (click)="onUnfavouriteProperty()"></i> Already
                            Favourite
                        </button>
                        <!-- <button *ngIf="!is_fav" class="btn fav w-100 mb-2">
                            <i class="fa fa-solid fa-heart-o social-icon" (click)="favouriteProperty()"></i> Add to
                            Favourite
                        </button> -->
                        <ng-container *ngIf="brochures && brochures.length > 0">
                            <ng-container *ngFor="let b of brochures">
                                <button *ngIf="b != ''" (click)="downloadBrochure(b)" class="btn fav w-50 mt-5">Download
                                    Brochure</button>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <!-- Featured Listings (You'll need data for these, currently placeholders) -->
                

                <!-- Related Property (Single Card Below Featured) - Placeholder for now -->
                

            </div>
        </div>
   
</main>

<!-- Swiper Gallery for more images -->
<section class="related-listings-bottom-section" *ngIf="propertyImages && propertyImages.length > 3">
    <div class="container">
        <h2 class="section-heading">More Photos</h2>
        <div class="row">
            <div class="col-12" style="margin-top: 50px;">
                <swiper [config]="swiperOp" [spaceBetween]="20" (slideChange)="onSlideChange()">
                    <ng-container *ngFor="let data of propertyImages; let i = index">
                        <ng-template swiperSlide *ngIf="i > 2"> <!-- Start from the 4th image (index 3) -->
                            <img class="slide-img" [src]="shared.getImageURL(data.image)">
                        </ng-template>
                    </ng-container>
                </swiper>
            </div>
        </div>
    </div>
</section>

<!-- Related Listings Bottom Section (You'll need actual related listings data) -->
<div class="container">
        <div class="row">
             <h3 class="section-heading">Related Photos</h3>
            <div class="col-12" class="related-photos">
                <swiper [config]="swiperOp" [spaceBetween]="20" (slideChange)="onSlideChange()">
                    <ng-container *ngFor="let data of propertyImages">
                        <ng-template swiperSlide><img class="slide-img"
                                [src]="shared.getImageURL(data.image)"></ng-template>
                    </ng-container>
                </swiper>
            </div>
        </div>
    </div>

<!-- <li class="check" *ngIf="propertyData && propertyData.PropertyToPropertyAmenitiesData && propertyData.PropertyToPropertyAmenitiesData[0].pool != null"><span class="fa fa-check-circle icon"></span>Pool</li>


<li class="check" *ngIf="propertyData && propertyData.PropertyToPropertyAmenitiesData && propertyData.PropertyToPropertyAmenitiesData[0].furnished_type != null"><span class="fa fa-check-circle icon"></span>
    {{propertyData.PropertyToPropertyAmenitiesData[0].furnished_type == 1 ? 'Furnushed' : ''}}
    {{propertyData.PropertyToPropertyAmenitiesData[0].furnished_type == 2 ? 'Semi Furnushed' : ''}}
    {{propertyData.PropertyToPropertyAmenitiesData[0].furnished_type == 3 ? 'UnFurnushed' : ''}}
</li>

<li class="check" *ngIf="propertyData && propertyData.PropertyToPropertyAmenitiesData && (propertyData.PropertyToPropertyAmenitiesData[0].is_gate_security!= null && propertyData.PropertyToPropertyAmenitiesData[0].is_gate_security == true)"><span class="fa fa-check-circle icon"></span>
    Gate Security
</li> -->


<div class="modal fade" id="socialModal" tabindex="-1"
    data-backdrop="static" data-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="socialModalLabel">
                    Contact details
                </h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div class="card"
                    *ngIf="subscriptionInfo && (subscriptionInfo.hasSubscription && !subscriptionInfo.result)">
                    <div class="card-body">
                        <h5 class="card-text text-center alert alert-danger">
                            You have reached your limit. You cannot view more property. If you want to view more property, please <a class="contact-link" href="contact"><span style="color: blue;">contact us</span></a>.
                         </h5>
                    </div>
                </div>

                <div class="card mt-3" *ngIf="subscriptionInfo && !subscriptionInfo.hasSubscription">
                    <div class="card-body">
                        <h5 class="card-text text-center alert alert-danger">
                            You cannot view property. Please subscribe to view property.
                        </h5>
                        <div class="text-center">
                            <a href="subscription-buyer-plan" class="btn btn-primary btn-theme">Subscribe Now</a>
                        </div>
                    </div>
                </div>
                <!-- <form id="socialForm" [formGroup]="socialForm" name="socialForm" 
                class="socialForm" method="POST"> -->
                <ng-container *ngIf="propertyDataInfo">
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">Contact:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'phone')">
                            <p>{{propertyDataInfo.PropertyToUserData.phone}}</p>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">Email:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'email')">
                            <p>{{propertyDataInfo.PropertyToUserData.email}}</p>
                            <!-- <input type="email" class="form-control" formControlName="email"> -->
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">WhatsApp Number:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'wp')">
                            <p>{{propertyDataInfo.PropertyToUserData.whatsapp_no ?
                                propertyDataInfo.PropertyToUserData.whatsapp_no :
                                propertyDataInfo.PropertyToUserData.phone}}</p>
                            <!-- <input type="number" class="form-control" formControlName="whatsapp_number"> -->
                        </div>
                    </div>
                </ng-container>
                <!-- </form> -->

            </div>
            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
            </div> -->
        </div>
    </div>
</div>
  <div class="modal fade" id="inquiryModal" tabindex="-1" aria-labelledby="inquiryModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="inquiryModalLabel">Connect with {{propertyData?.PropertyToDeveloper?.developer_name}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <form (ngSubmit)="submitInquiry()" #inquiryForm="ngForm">
              <div class="mb-3">
                <label class="form-label">Name</label>
                <input type="text" class="form-control" name="name" [(ngModel)]="inquiryData.name" required />
              </div>

              <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="email" class="form-control" name="email" [(ngModel)]="inquiryData.email" required />
              </div>

              <div class="mb-3">
                <label class="form-label">Phone</label>
                <input type="text" class="form-control" name="phone" [(ngModel)]="inquiryData.phone" required />
              </div>

              <div class="text-end">
                 <button type="submit" class="btn btn-primary" [disabled]="inquiryForm.invalid">Submit</button>
                <button type="button" class="btn btn-secondary ms-2" data-bs-dismiss="modal">Cancel</button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
